import { stringify } from 'qs';
import request from '@/utils/request';
import { formDataCode } from '@/utils/utils';

// 账号密码校验
export async function AliCheckLoginNew(params) {
  return request('/api/Login/AliCheckLoginNew', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formDataCode(params),
  });
}

// 账号登录验证码发送
export async function SendAliSmsCode(params) {
  return request('/api/Login/SendAliSmsCodeNew', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formDataCode(params),
  });
}

export async function SendRegSmsCodeNew(params) {
  return request('/api/Register/SendRegSmsCodeNew', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formDataCode(params),
  });
}

export async function SendAliSmsCodes(params) {
  return request('/api/FindPwd/SendAliSmsCodeNew', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formDataCode(params),
  });
}
